import { render, staticRenderFns } from "./AutomotiveChallenges.vue?vue&type=template&id=3f2abd60&scoped=true&"
import script from "./AutomotiveChallenges.vue?vue&type=script&lang=js&"
export * from "./AutomotiveChallenges.vue?vue&type=script&lang=js&"
import style0 from "./AutomotiveChallenges.vue?vue&type=style&index=0&id=3f2abd60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2abd60",
  null
  
)

export default component.exports